import React, { ReactNode } from 'react';

import { InfoCardTitle } from 'common/components/Card/InfoCard';
import { Container } from 'common/components/Card/InfoCard/InfoCard.styled';

export interface IInfoCardProps {
  title?: string;
  isInsideForm?: boolean;
  justifyContent?: string;
  padding?: string;
  children?: ReactNode;
}

export const InfoCard = ({
  title,
  isInsideForm,
  justifyContent,
  children,
  padding,
}: IInfoCardProps) => {
  return (
    <Container isInsideForm={isInsideForm} justifyContent={justifyContent} padding={padding}>
      {title && <InfoCardTitle title={title} />}
      {children}
    </Container>
  );
};
